import React from 'react';
import styles from './css/index.module.css';
import { Delete20Regular } from '@fluentui/react-icons';
import { ndaExtensions } from '../../utils/misc';
import { AddNda } from '../../redux/projectDataSlice';
import { useDispatch, useSelector } from 'react-redux';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import format from 'date-fns/format';

const UploadNda = ({ setSelectedView, createdProjectData, setCreatedProjectData }) => {
    const { ndaButtonLoading } = useSelector(state => state.projectData);
    const [uploadedFile, setUploadedFile] = React.useState();
    const [isDragging, setIsDragging] = React.useState(false);
    const fileInputRef = React.useRef();
    const dispatch = useDispatch();

    const handleDivClick = () => {
        fileInputRef.current.click();
    };

    const processFile = file => {
        if (file && ndaExtensions.some(ext => file.name.toLowerCase().endsWith(`.${ext}`))) {
            setUploadedFile(file);
        }
    };

    const handleFileChange = e => {
        const selectedFiles = Array.from(e.target.files);
        if (selectedFiles?.length > 0) {
            processFile(selectedFiles[0]);
        }
    };

    const handleDragEnter = e => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(true);
    };

    const handleDragLeave = e => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);
    };

    const handleDragOver = e => {
        e.preventDefault();
        e.stopPropagation();
    };

    const handleDrop = e => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);

        const files = Array.from(e.dataTransfer.files);
        if (files?.length > 0) {
            processFile(files[0]);
        }
    };

    const handleSubmit = async e => {
        e.preventDefault();
        const FiletoUpload = new FormData();
        FiletoUpload.append('document', uploadedFile);
        FiletoUpload.append('expiry', format(new Date(), 'yyyy-MM-dd'));
        const res = await dispatch(AddNda(FiletoUpload));
        if (res?.type !== 'POST_NDA_DOC/rejected') {
            setSelectedView('organisationDetail');
            setCreatedProjectData({
                ...createdProjectData,
                vdr: {
                    ...createdProjectData?.vdr,
                    nda: res?.payload?.data,
                },
            });
        }
    };

    return (
        <div className={styles.componentCard}>
            <h5 className={styles.componentTitle}>Upload Project NDA</h5>
            {uploadedFile ? (
                <div className={styles.uploadItemsList}>
                    <div className={styles.fileListItem}>
                        <span>{uploadedFile?.name}</span>
                        <Delete20Regular role="button" onClick={() => setUploadedFile()} />
                    </div>
                </div>
            ) : (
                <div
                    id="uploadDiv"
                    className={`${styles.uploadBox} ${isDragging ? styles.dragging : ''}`}
                    onClick={handleDivClick}
                    onDragEnter={handleDragEnter}
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    onDrop={handleDrop}>
                    <span className={styles.uploadTextDragDrop}>
                        Drag & drop NDA file or
                        <br />
                        click to upload
                        <br />
                        <br />
                        <small>({ndaExtensions.map(ext => ext.toUpperCase()).join(', ')})</small>
                    </span>
                    <input
                        multiple={false}
                        type="file"
                        accept={ndaExtensions.map(ext => `.${ext}`).join(',')}
                        ref={fileInputRef}
                        style={{ display: 'none' }}
                        onChange={handleFileChange}
                    />
                </div>
            )}
            <div className="d-flex align-items-center justify-content-between">
                <button disabled={ndaButtonLoading || !uploadedFile} onClick={handleSubmit} className={styles.submitButton}>
                    Save {ndaButtonLoading && <AiOutlineLoading3Quarters className="rotateLoader" />}
                </button>
                <span onClick={() => setSelectedView('organisationDetail')} className={styles.linkBtn}>
                    Skip
                </span>
            </div>
        </div>
    );
};

export default UploadNda;
